<div class="add-box" id="block-menu" [style.display]="contentBoxShow && isContentBoxOpened  ? 'block': 'none'">
  <ul>
    <li class="add-box-title">Add Content</li>
    <li class="add-box-description">Drag a content element to the page.</li>
    <li class="editor-block ui-draggable ui-draggable-handle " [dndDraggable]="draggableWithDragText"
      (dndStart)="onDragStart($event)" (dndEnd)="onDragEnd($event)" (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)">
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          description
        </span>
      </span>
      Text
    </li>
    <li class="editor-block ui-draggable ui-draggable-handle" [dndDraggable]="draggableWithDragTab"
      (dndStart)="onDragStart($event)" (dndEnd)="onDragEnd($event)" (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)">
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          tab
        </span>
      </span>
      Tabs
    </li>
    <li class="editor-block ui-draggable ui-draggable-handle" [dndDraggable]="draggableWithDragImage"
      (dndStart)="onDragStart($event)" (dndEnd)="onDragEnd($event)" (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)">
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          insert_photo
        </span>
      </span>
      Image
    </li>
    <li class="editor-block ui-draggable ui-draggable-handle challenge-padding"
      [dndDraggable]="draggableWithDragChallenge" (dndStart)="onDragStart($event)" (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)" (dndDrag)="onDrag($event)">
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          assignment_ind
        </span>
      </span>
      Link to Challenge
    </li>

    <li class="editor-block ui-draggable ui-draggable-handle" [dndDraggable]="draggableWithDragVideo"
      (dndStart)="onDragStart($event)" (dndEnd)="onDragEnd($event)" (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)">
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          video_library
        </span>
      </span>
      Video
    </li>
    <li class="editor-block ui-draggable ui-draggable-handle" [dndDraggable]="draggableWithDragAudio"
      (dndStart)="onDragStart($event)" (dndEnd)="onDragEnd($event)" (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)">
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          volume_up
        </span>
      </span>
      Audio
    </li>

    @if (isCopyPasteContentExist.isCopyExist) {
      <li class="editor-block ui-draggable ui-draggable-handle"
        [dndDraggable]="draggableWithDragCopyPaste" (dndStart)="onDragStart($event, true)" (dndEnd)="onDragEnd($event)"
        (dndMoved)="onDragMoved($event)" (dndDrag)="onDrag($event, true)">
        <span class="editor-content-block">
          <span class="material-icons material-content-icons">
            content_paste
          </span>
        </span>
        {{isCopyPasteContentExist.rowCopied ? 'Paste Row' : 'Paste'}}
      </li>
    }
  </ul>
</div>

<nav class="head" (click)="clearSelectedEditor(false)">
  <div class="left">
    <a [href]="returnUrl" id="closePlayBookAddPageDialogId" placement="bottom" container="body" tooltip="Close">
      <span class="icon ic-close" style="bottom: 0px; padding: 0px;"><i class="material-icons">clear</i></span>
    </a>
    <a class="title" href="javascript:void(0)" (click)="scrollToTop(null)">
      <span style="color: white;">Page Template Editor -</span>
      <span> {{pageTemplate.name}}</span>
    </a>
  </div>
  <div class="right me-4">
    <a id="expandTag" appFullScreen class="playbook-support-link">
      @if (screenfull.isEnabled && !screenfull.isFullscreen) {
        <span placement="bottom" container="body"
          tooltip="Expand Playbook">
          <i class="material-icons">fullscreen</i>
        </span>
      }
      @if (screenfull.isEnabled && screenfull.isFullscreen) {
        <span placement="bottom" container="body"
          tooltip="Collapse Playbook">
          <i class="material-icons">fullscreen_exit</i>
        </span>
      }
    </a>
    <a (click)="toggleDrawer()" id="pageSectionAttachedResourceButtonId" placement="bottom" appSwipeShow
      container="body" tooltip="View Attached Resources">
      <span><i class="material-icons">attach_file</i></span>
      <span class="clip-res-count count">{{resourceCounts}}</span>
    </a>
    <div class="edit-mode-icons">
      @if (languageId === defaultLanguageId) {
        <a [class.disabled]="isTouchDevice" class="edit-icon"
          id="block-menu-button" (click)="showBlockMenuFunc()">
          <span class="material-icons" [ngClass]="isServerProcess ? 'opacity05': 'opacity1'" placement="bottom"
            container="body" tooltip="Add Content">
            add
          </span>
        </a>
      }
    </div>
  </div>
</nav>
<nav id="side-nav-{{container.id}}" class="side side-nav" (click)="clearSelectedEditor(true)">
  <div class="scroll-cont">
    <div class="side-cont">
      <div id="side-cont-box-{{container.id}}" class="side-cont-box sidebar-scroll">
        <div class="sections">
          @if (!container.isCurrentPageInDraftMode && list.sections.length>0) {
            <ul cdkDropList (cdkDropListDropped)="onSectionItemDrop($event)"
              class="section-containers">
              @for (cont of list.sections | orderBy:'orderBy'; track cont) {
                <li id="section-{{cont.id}}" cdkDrag
                  [hidden]="cont.title == undefined && cont.title == null && cont.title == ''"
                  [cdkDragDisabled]="languageId !== defaultLanguageId">
                  <a id="section-link-{{cont.id}}" [class.current]="cont.on" (click)="showSection(cont)">{{cont.title}}</a>
                  <a class="edit" style="z-index: 1333;" (click)="editContainer(cont)" placement="bottom" container="body"
                    tooltip="Edit Item">
                    <i class="material-icons md-18">create</i>
                  </a>
                  @if (languageId === defaultLanguageId) {
                    <a style="z-index: 1333;" class="reorder" placement="bottom"
                      container="body" tooltip="Reorder Item">
                      <i class="material-icons md-18">open_with</i>
                    </a>
                  }
                </li>
              }
            </ul>
          }

          @if (container.isCurrentPageInDraftMode && list.draftSection.length>0) {
            <ul cdkDropList (cdkDropListDropped)="onSectionItemDrop($event)"
              class="section-containers">
              @for (cont of list.draftSection | orderBy:'orderBy'; track cont) {
                <li id="section-{{cont.id}}" cdkDrag
                  [hidden]="cont.title == undefined && cont.title == null && cont.title == ''"
                  [cdkDragDisabled]="languageId !== defaultLanguageId">
                  <a id="section-link-{{cont.id}}" [class.current]="cont.on" (click)="showSection(cont)">{{cont.title}}</a>
                  <a class="edit" style="z-index: 1333;" (click)="editContainer(cont)" placement="bottom" container="body"
                    tooltip="Edit Item">
                    <i class="material-icons md-18">create</i>
                  </a>
                  @if (languageId === defaultLanguageId) {
                    <a style="z-index: 1333;" class="reorder" placement="bottom"
                      container="body" tooltip="Reorder Item">
                      <i class="material-icons md-18">open_with</i>
                    </a>
                  }
                </li>
              }
            </ul>
          }
          @if (languageId === defaultLanguageId) {
            <a (click)="addSection()" class="add-container">Add Section <i
            class="material-icons md-18">add_circle_outline</i></a>
          }
        </div>
      </div>
    </div>
  </div>
</nav>
@if (container.on) {
  <article #contentBox class="content" id="content-{{container.id}}"
    (click)="clearSelectedEditor(true);$event.stopPropagation;">
    <app-container-content [Container]="container" [pageTemplateId]="pageTemplate.id"
      [isDraftMode]="isCurrentPageInDraftMode">
    </app-container-content>
  </article>
}